<template>
    <div ref="note-modal" uk-modal class="job-notes">
        <div class="uk-modal-dialog uk-modal-dialog-wide uk-modal-body business-unit-form">
            <i v-if="!editMode" class="fa fa-edit" @click="editNotes"></i>
            <div v-if="!editMode" class="job-note">{{ notes }}</div>
            <textarea ref="edit-box" v-model="notes" v-if="editMode" class="job-note-edit"></textarea>
            <button v-if="editMode" type="button" class="uk-button uk-button-primary" @click="saveNotes" >
				<i class="fas fa-save"></i>
				Save & Continue
			</button>
            <button type="button" class="uk-button uk-button-secondary" @click="closeNotes" >Cancel</button>
        </div>

	</div>
</template>

<script>
    export default {
        name: "JobRequestNotes",
        data() {
            return {
                jobRequestId:null,
                notes:"",
                editMode: false,
                loadedIndex: -1,
                lastCaller: null
            }
        },
        mounted() {

        },
        methods: {
            loadNotes: function(notes, jrId, index, caller){
                this.editMode = false;
                this.notes = notes;
                this.jobRequestId = jrId;
                this.loadedIndex = -1;
                this.lastCaller = caller;

                if(!this.jobRequestId){
                    this.loadedIndex = index;
                }

                UIkit.modal(this.$refs["note-modal"]).show();
            },
            closeNotes(){
                this.editMode = false;
                UIkit.modal(this.$refs["note-modal"]).hide();
            },
            saveNotes(){
                this.notes = this.notes.trim();

                if(this.jobRequestId){
                    //console.log("I would send it to update the notes on Job " + this.jobRequestId);
                    axios.post("/api/requisition/save/job/note/" + this.jobRequestId, {
                        note: this.notes
                    }).then(
                        (pack) => this.submissionComplete(pack),
                        (pack) => this.submissionComplete(pack)
                    );
                } else {
                    this.lastCaller ? this.lastCaller.cacheBack(this.notes, this.loadedIndex):null;
                }

                this.closeNotes();
            },
            submissionComplete(pack){
                if(pack.data.success){
                    this.lastCaller ? this.lastCaller.updateItem(this.notes, this.jobRequestId):null;
                }
            },
            editNotes(){
                this.editMode = true;
                setTimeout(() => function(){
                    console.log(this.$refs["edit-box"]);
                    this.$refs["edit-box"].focus();
                }, 1);

            }
        }
    }
</script>
